import { z } from "zod";

import { organisationSchema } from "./organisation.type";
import { questionnaireSchema } from "./questionnaire.type";

export const questionnaireResponseSchema = z.object({
  id: z.string({ coerce: true }),
  organisationId: organisationSchema.shape.id,
  questionnaireId: questionnaireSchema.shape.id,
  createdAt: z.date({ coerce: true })
});

export type QuestionnaireResponse = z.infer<typeof questionnaireResponseSchema>;
